import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // For navigation after form submission

const SetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken'); 
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic password validation
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    // Prepare the payload for the PUT request
    const registration = true; // This can be dynamic, depending on whether it's the first time or a password change
    const oldPassword = ''; // Add the old password if it's a change (set as empty if it's registration)
    const newPassword = password;

    const payload = {
      registration,
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };

    try {
      // Make the PUT request to update the password
      const response = await fetch('https://beta.flowlogic.com/api/users/update_password/', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          // Add Authorization if needed (e.g. Bearer Token)
          'Authorization': `Bearer ${authToken}`,  // Include access token
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setError('');
        setSuccessMessage('Password has been successfully updated!');
        // Navigate to a different page (login, dashboard, etc.)
        // navigate('/circle-filter');
        setTimeout(() => {
          navigate('/dashboard');
          // navigate('/points');
        }, 2000);
      } else {
        setError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please try again later.');
    }
  };

  return (
    <div className="set-password-container">
         <div className="logo"><img src={"/assets/Flowlogic-Logo.svg"} alt="FlowLogic Icon" /></div>
      <h4>Set Your Password</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter Password"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm Password"
            required
          />
        </div>

        {error && <div className="error-message">{error}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}

        <button type="submit" className="btn btn-success">Set Password</button>
      </form>
    </div>
  );
};

export default SetPassword;
